module.exports = __webpack_public_path__ + "static/media/home-img-2.51d4851a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro/home-img-2.svg
// module id = 667
// module chunks = 0